import o from "./useKey.js";
const c = (e) => {
  o((s) => s.key === "Escape" && e(s));
};
export {
  c as default
};
//# sourceMappingURL=useEsc.js.map
